import { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { AdminContext } from "../../context/adminContext";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import ErrorMessage from "../../UI/ErrorMessage/ErrorMessage";
import ButtonEdit from "../../UI/ButtonEdit/ButtonEdit";
import LittleNotify from "../../UI/Notification/LittleNotify/LittleNotify";
import ButtonBack from "../../UI/ButtonBack/ButtonBack";
import TestPermitTable from "../../components/TestPermitTable/TestPermitTable";

const RetakeTest = () => {
  const params = useParams();

  const { getRetakeTestById, postRetakeTest } = useContext(AdminContext);

  const [error, setError] = useState(null);
  const [category, setCategory] = useState(null);
  const [results, setResults] = useState(null);
  const [success, setSuccess] = useState(null);
  const [errorNotify, setErrorNotify] = useState(null);

  useEffect(() => {
    getRetakeTestById(params.id).then((res) => {
      if (res.response) {
        return setError(res.response.data.message);
      }
      document.title = 'Пересдача "' + res.data.category.category + '"';
      setCategory(res.data.category);
      setResults(res.data.users);
    });
  }, []);

  const closeErrorNotify = () => {
    setErrorNotify(null);
  };

  const closeSuccess = () => {
    setSuccess(null);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    const user_id = e.target[0].value;
    const category_id = e.target[1].value;
    postRetakeTest(user_id, category_id).then((res) => {
      if (res.response) {
        if (res.response.data.message) {
          setErrorNotify(res.response.data.message);
          setTimeout(() => {
            setErrorNotify(null);
          }, 12000);
          return;
        }
      }

      setResults((prev) => {
        return prev.filter((user) => user.id != user_id);
      });
      setSuccess(res.data);
      setTimeout(() => {
        setSuccess(null);
      }, 12000);
    });
  };

  return (
    <div className="container">
      <div className="admin__retake">
        <ButtonBack shortBtn={true} />
        <div className="admin__retake__title">Разрешение на пересдачу</div>

        {results == null && !error ? (
          <div style={{ position: "relative", minHeight: 120 }}>
            <CoveredBackground>
              <Loader />
            </CoveredBackground>
          </div>
        ) : category.blocked == 1 ? (
          <>
            <div className="admin__retake__title">
              Категория: {category.category}
            </div>
            <ErrorMessage message={"Недоступная категория"} />
          </>
        ) : results == 0 ? (
          <ErrorMessage message={"Нет данных"} />
        ) : (
          <>
            <div className="admin__retake__title">
              Категория: {category.category}
            </div>

            <TestPermitTable users={results} submithandler={submitHandler} category={category.id}/>
          </>
        )}
      </div>
      {errorNotify && (
        <LittleNotify
          title={errorNotify}
          close={closeErrorNotify}
          error={true}
        />
      )}
      {success && <LittleNotify title={success} close={closeSuccess} />}
    </div>
  );
};

export default RetakeTest;
